import { UntypedFormGroup } from '@angular/forms';

/**
 * Takes a formGroup.value as object, iterates through the values and trims them
 */
export function trimWhitespacesOfFormValues(formGroupValues: Object): Object {
    for (const [key, value] of Object.entries(formGroupValues)) {
        if (typeof value === 'string' && value.length > 0) {
            formGroupValues[key] = value.trim();
        }
    }

    return formGroupValues;
}

/**
 * Takes a formGroup.value as object, iterates through the values and transforms empty strings to null
 */
export function transformEmptyStringsToNullInFormValues(formGroupValues: Object): Object {
    for (const [key, value] of Object.entries(formGroupValues)) {
        if (typeof value === 'string' && value === '') {
            formGroupValues[key] = null;
        }
    }

    return formGroupValues;
}

export function isValidForm(formGroup: UntypedFormGroup, markAsTouched = false, markAsDirty = true): boolean {
    Object.values(formGroup.controls).forEach(control => {
        if (markAsDirty) {
            control.markAsDirty({ onlySelf: true });
        }

        if (markAsTouched) {
            control.markAsTouched({ onlySelf: true });
        }
    });

    return formGroup.valid;
}

export const FormUtils = {
    trimWhitespacesOfFormValues,
    transformEmptyStringsToNullInFormValues,
    isValidForm,
};
